module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Nomenclature"
    }
  }, [_c('p', {
    staticClass: "fm_h1",
    attrs: {
      "id": "sec3"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xvii",
      "title": "xvii"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253063526_Contents#rsec3"
    }
  }, [_vm._v("NOMENCLATURE")])])]), _vm._v(" "), _c('p', {
    staticClass: "sh"
  }, [_vm._v("PROPER NAMES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_para"
  }, [_vm._v("Significant variation can arise in certain proper names and surnames. Within the translated text, the spelling of proper names has generally been normalized in line with the orthographical conventions of "), _c('i', [_vm._v("An Caighdeán Oifigiúil")]), _vm._v(" (2017), the official standard for writing in Irish, e.g., Diarmuid > Diarmaid; Mícheál > Micheál; Pilip > Pilib; Séamus > Séamas; Maoilre > Maolra; Marcus > Marcas; Nápla > Nábla. Bairtle has been normalized as Beairtle. Pádhraic and Pádraigín have been normalized as Pádraic and Pádraicín respectively. In general, historical orthography has been used in surnames such as Mac Donnchadha, Ó Domhnaill, Ó Donnchadha, Ó Flaithearta, Ó Geannáin, Ó Laidhe. The following normalizations have also been implemented: Ó Curraidhin > Ó Curraoin; Grialais > Griallais; Mac Con Ríogh/Raoi > Mac Con Rí; Ó Ní > Ó Nia. The surnames Ó Conaola/Ó Conghaile have been rendered as Conneely.")]), _vm._v(" "), _c('p', {
    staticClass: "sh"
  }, [_vm._v("PLACENAMES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_para"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xviii",
      "title": "xviii"
    }
  }, [_vm._v("Placenames in Iorras Aithneach and elsewhere within the Gaeltacht are generally given in Irish. Conamara refers to traditionally Irish-speaking areas in Connemara. Established English language versions of placenames are capitalized and given in parentheses following the Irish language version. Generic English language glosses of Irish placenames are not capitalized. A number of these placenames have well-established English forms and are also used in the text, for example, An Cheathrú Rua ~ Carraroe; Garmna ~ Gorumna Island. Further information regarding the history and usage of placenames within the text can be found in Gazetteer, which accompanied Tim Robinson’s map of Connemara (1990).")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-86175dae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780253063526_Frontmatter04.vue
// module id = 84
// module chunks = 0